import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { handleError } from 'components/error'
import { LoadingIndicator } from 'components/loading'
import { useNotificacaoSinanQuery } from 'graphql/hooks.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { useEffect, useMemo } from 'react'

import { convertNotificacaoSinanQueryToForm } from './converter-notificacaoAgravo'
import {
  Cid10NotificacaoAgravoModel,
  IdNomeNotificacaoModel,
  NotificacaoAgravoFormModel,
} from './model-notificacaoAgravo'
import { NotificacaoAgravoModal } from './NotificacaoAgravoModal'

interface NotificacaoAgravoModalContainerProps {
  cid10s: ReadonlyArray<Cid10NotificacaoAgravoModel>
  onClose(): void
}

export function NotificacaoAgravoModalContainer(props: Readonly<NotificacaoAgravoModalContainerProps>) {
  const { cid10s, onClose } = props

  const acessoLotacaoOrEstagio = useAcessoLotacaoOrEstagio()
  const acesso = acessoLotacaoOrEstagio?.acesso

  const { atendimentoProfissional } = useAtendimentoContext()
  const atendimentoProfissionalId = atendimentoProfissional?.id

  const { data, loading, error } = useNotificacaoSinanQuery({
    variables: { input: { atendimentoProfissionalId } },
    skip: !atendimentoProfissionalId,
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (error) {
      handleError({ error })
      onClose()
    }
  }, [error, onClose])

  const notificacaoSinan = data?.notificacaoSinan

  const initialValues = useMemo<NotificacaoAgravoFormModel>(
    () => ({
      ...(notificacaoSinan && convertNotificacaoSinanQueryToForm(notificacaoSinan)),
      notificacao: {
        unidadeSaude: toIdNome(acesso?.unidadeSaude),
        municipio: toIdNome(acesso?.municipio),
        uf: toIdNome(acesso?.municipio?.uf),
      },
    }),
    [acesso, notificacaoSinan]
  )

  const handleSubmit = (_values: NotificacaoAgravoFormModel) => {
    // TODO: enviar a notificação de agravo para o SINAN (#35068).
    onClose()
  }

  if (loading) return <LoadingIndicator />
  if (error) return null

  return (
    <NotificacaoAgravoModal cid10s={cid10s} initialValues={initialValues} onClose={onClose} onSubmit={handleSubmit} />
  )
}

const toIdNome = (item?: { id: ID; nome?: string | null }): IdNomeNotificacaoModel | undefined =>
  item?.nome ? { id: item.id, nome: item.nome } : undefined
